import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient, HttpHeaders }from '@angular/common/http';
import { CompanyPerson, PagedResponseCompanyPerson } from '../models/CompanyPerson';
import { environment } from 'src/environments/environment';
import { tap} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})



export class CompanyPersonService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

 companyPersons : CompanyPerson[]=[];

  getCompanyPerson(value: string, kaizenCreatorEmailId: string, kaizenLeaderEmailId: string):Observable<PagedResponseCompanyPerson> {
    return  this.http.get<PagedResponseCompanyPerson>(this.APIURL+'/CompanyPerson' + '?PageNumber=1&PageSize=50' + "&Value=" + value + "&KaizenCreatorEmailId=" + kaizenCreatorEmailId + "&KaizenLeaderEmailId=" + kaizenLeaderEmailId)
                     .pipe(tap(data => this.companyPersons = data.data))
  }

  gerCompanyPersonByEmail(emailId: string):Observable<CompanyPerson>
  {
    return this.http.get<CompanyPerson>(this.APIURL+'/CompanyPerson/GetCompanyPersonByEmail/'+ emailId);
               
  }

}